<template>
  <v-card elevation="0" rounded="0" color="borderInner" style="width: 100%; height: 100%;">
    <div v-if="loader.selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponent" style="width: 100%; height: 100%; display: flex; text-align: center; align-items: center; justify-content: center;">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else style="width: 100%; height: 100%; display: flex; flex-direction: column;">
      <div style="display: flex; flex-direction: row; padding: 10px; gap: 10px; align-items: center;">
        <v-text-field
          ref="CRMAgentQuickMessageSearchQuery"
          v-model="input.CRMAgentQuickMessageSearchQuery"
          :append-inner-icon="input.CRMAgentQuickMessageSearchQuery && /\S/.test(input.CRMAgentQuickMessageSearchQuery) ? 'mdi-magnify-remove-outline' : 'mdi-magnify'"
          @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMAgentQuickMessageSearchQuery'); input.CRMAgentQuickMessageSearchQuery = null"
          label="Buscar mensaje rápido"
          variant="solo-filled"
          density="compact"
          autocomplete="off"
          hide-details 
        ></v-text-field>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Agregar mensaje rápido" location="bottom">
          <template v-slot:activator="{ props }">
            <v-icon @click="openCRMAgentQuickMessageDialog('insert', null)" icon="mdi-plus-circle" color="primary" class="hoverableElement" v-bind="props"></v-icon>
          </template>
        </v-tooltip>
      </div>
      <div style="flex: 1 1 0; min-height: 0; display: flex; flex-direction: column; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
        <v-data-table :headers="display.CRMAgentQuickMessagesHeaders" :items="filteredCRMAgentQuickMessage" :items-per-page="filteredCRMAgentQuickMessage.length > 25 ? 25 : -1" :fixed-header="true" style="flex: 1 1 0; min-height: 0;">
          <template v-slot:header.CRMAgentQuickMessageID>
            <p><strong>ID</strong></p>
          </template>
          <template v-slot:header.CRMAgentQuickMessageName>
            <p><strong>NOMBRE</strong></p>
          </template>
          <template v-slot:header.CRMAgentQuickMessageDescription>
            <p><strong>DESCRIPCIÓN</strong></p>
          </template>
          <template v-slot:header.CRMAgentQuickMessageContent>
            <p><strong>CONTENIDO</strong></p>
          </template>
          <template v-slot:item.CRMAgentQuickMessageDescription="{ item }">
            <p style="max-width: 400px; max-height: 100px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none; white-space: pre-line;">{{ item.CRMAgentQuickMessageDescription && /\S/.test(item.CRMAgentQuickMessageDescription) ? item.CRMAgentQuickMessageDescription : 'Sin descripción' }}</p>
          </template>
          <template v-slot:item.CRMAgentQuickMessageContent="{ item }">
            <div v-if="item.CRMAgentQuickMediaMessageMediaURL">
              <img v-if="item.CRMAgentQuickMediaMessageMediaExtension == 'webp'" @click="this.$root.dialogComponent.openMediaDialog(item.CRMAgentQuickMediaMessageMediaURL, item.CRMAgentQuickMediaMessageMediaName, item.CRMAgentQuickMediaMessageMediaExtension)" :src="item.CRMAgentQuickMediaMessageMediaURL" draggable="false" class="hoverableText" style="height: 100px; width: auto;">
              <video v-else-if="item.CRMAgentQuickMediaMessageMediaExtension == 'mp4'" @click="this.$root.dialogComponent.openMediaDialog(item.CRMAgentQuickMediaMessageMediaURL, item.CRMAgentQuickMediaMessageMediaName, item.CRMAgentQuickMediaMessageMediaExtension)" :src="item.CRMAgentQuickMediaMessageMediaURL" controls draggable="false" class="hoverableText" style="height: 100px; width: auto;"></video>
              <iframe v-if="item.CRMAgentQuickMediaMessageMediaExtension == 'pdf'" :src="item.CRMAgentQuickMediaMessageMediaBlob" :title="item.CRMAgentQuickMediaMessageMediaName" draggable="false" class="hoverableText" style="height: 100px; width: auto;"></iframe>
              <p v-if="item.CRMAgentQuickMediaMessageCaption" style="max-width: 400px; max-height: 100px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none; color: grey; font-size: small; white-space: pre-line;">{{ item.CRMAgentQuickMediaMessageCaption }}</p>
            </div>
            <div v-else>
              <p style="max-width: 400px; max-height: 100px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none; white-space: pre-line;">{{ item.CRMAgentQuickTextMessageContent }}</p>
            </div>
          </template>
          <template v-slot:item.CRMAgentQuickMessageUpdateAction="{ item }">
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Actualizar mensaje rápido" location="bottom">
              <template v-slot:activator="{ props }">
                <v-icon @click="openCRMAgentQuickMessageDialog('update', item)" icon="mdi-pencil" color="warning" class="hoverableElement" v-bind="props"></v-icon>
              </template>
            </v-tooltip>
          </template>
          <template v-slot:item.CRMAgentQuickMessageDeleteAction="{ item }">
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Eliminar mensaje rápido" location="bottom">
              <template v-slot:activator="{ props }">
                <v-icon @click="openCRMAgentQuickMessageDialog('delete', item)" icon="mdi-delete" color="error" class="hoverableElement" v-bind="props"></v-icon>
              </template>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <div v-if="display.CRMAgentQuickMessage.length != filteredCRMAgentQuickMessage.length" @click="input.CRMAgentQuickMessageSearchQuery = null;" class="hoverableText" style="text-align: center; padding: 20px;">
              <v-icon size="large" color="grey">mdi-information</v-icon>
              <div style="margin-top: 10px; color: grey;">
                <p>No se encontraron mensajes rápidos con el criterio de búsqueda "<strong>{{ input.CRMAgentQuickMessageSearchQuery }}</strong>"</p>
                <p>Haz click <span class="hoverableText" style="text-decoration: underline;">aquí</span> para limpiar el criterio de búsqueda</p>
              </div>
            </div>
            <div v-else @click="openCRMAgentQuickMessageDialog('insert', null)" class="hoverableText" style="text-align: center; padding: 20px; user-select: none;">
              <v-icon size="large" color="grey">mdi-information</v-icon>
              <div style="margin-top: 10px; color: grey;">
                <p>No existen mensajes rápidos</p>
                <p>Haz click <span class="hoverableText" style="text-decoration: underline;">aquí</span> para agregar uno</p>
              </div>
            </div>
          </template>
          <template v-if="filteredCRMAgentQuickMessage.length <= 25" v-slot:bottom></template>
        </v-data-table>
      </div>
    </div>
  </v-card>

  <v-dialog v-model="navigation.CRMAgentQuickMessageDialogIsVisible" :persistent="loader.CRMAgentQuickMessageDialogLoader" max-width="50vw">
    <v-card max-width="50vw">
      <div v-if="loader.CRMAgentQuickMessageDialogLoader" style="display: flex; justify-content: center; align-items: center; width: 100%; padding: 10px 0px;">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <div v-if="navigation.CRMAgentQuickMessageAction == 'delete'">
          <v-alert type="error" variant="tonal" style="cursor: default; user-select: none;">
            <template v-slot:title>
              <h3>ATENCIÓN</h3>
            </template>
            <p style="margin-top: 5px;">El mensaje rápido <strong>{{ input.CRMAgentQuickMessageName }}</strong> será eliminado</p>
            <p>Esta acción es irreversible</p>
            <v-checkbox-btn v-model="input.deleteCRMAgentQuickMessageConfirmation" color="error" label="Estoy de acuerdo" hide-details class="hoverableText" style="margin-top: 10px;"></v-checkbox-btn>
            <div style="display: flex; gap: 10px; margin-top: 20px; width: 100%;">
              <v-btn @click="deleteCRMAgentQuickMessage()" :disabled="!input.deleteCRMAgentQuickMessageConfirmation" color="error" dark height="38" class="hoverableText" style="width: 50%;">
                <h3>ELIMINAR MENSAJE RÁPIDO</h3>
              <v-icon style="margin-left: 10px;" dark right>mdi-delete</v-icon>
              </v-btn>
              <v-btn @click="navigation.CRMAgentQuickMessageDialogIsVisible = false" color="primary" dark height="38" class="hoverableText" style="width: 50%;">
                <h3>CANCELAR</h3>
                <v-icon style="margin-left: 10px;" dark right>mdi-close-circle</v-icon>
              </v-btn>
            </div>
          </v-alert>
        </div>
        <div v-else style="padding: 15px;">
          <v-text-field 
            ref="CRMAgentQuickMessageName"
            v-model="input.CRMAgentQuickMessageName"
            :append-inner-icon="input.CRMAgentQuickMessageName && /\S/.test(input.CRMAgentQuickMessageName) ? 'mdi-alphabetical-variant-off' : 'mdi-alphabetical-variant'" 
            @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMAgentQuickMessageName'); input.CRMAgentQuickMessageName = null" 
            label="Nombre del mensaje rápido" 
            variant="solo-filled" 
            density="compact" 
            autocomplete="off" 
            hide-details
            style="margin-bottom: 15px;"
          ></v-text-field>
          <v-textarea 
            ref="CRMAgentQuickMessageDescription"
            v-model="input.CRMAgentQuickMessageDescription"
            :append-inner-icon="input.CRMAgentQuickMessageDescription && /\S/.test(input.CRMAgentQuickMessageDescription) ? 'mdi-alphabetical-off' : 'mdi-alphabetical'" 
            @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMAgentQuickMessageDescription'); input.CRMAgentQuickMessageDescription = null" 
            label="Descripción del mensaje rápido (opcional)" 
            variant="solo-filled" 
            density="compact" 
            autocomplete="off"
            rows="2"
            max-rows="4"
            auto-grow
            hide-details
            style="margin-bottom: 15px;"
          ></v-textarea>
          <v-select
            ref="CRMAgentQuickMessageType"
            v-if="navigation.CRMAgentQuickMessageAction == 'insert'"
            v-model="input.CRMAgentQuickMessageType"
            :items="['Mensaje de texto', 'Mensaje multimedia']"
            @update:model-value="input.CRMAgentQuickTextMessageContent = null; input.CRMAgentQuickMediaMessageMediaURL = null; input.CRMAgentQuickMediaMessageMediaExtension = null; input.CRMAgentQuickMediaMessageCaption = null"
            :append-inner-icon="input.CRMAgentQuickMessageType ? 'mdi-source-branch-remove' : 'mdi-source-branch'" 
            @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMAgentQuickMessageType'); input.CRMAgentQuickMessageType = null" 
            label="Tipo de mensaje rápido"
            variant="solo-filled"
            density="compact"
            autocomplete="off"
            hide-details
            style="margin-bottom: 15px;"
          ></v-select>
          <div v-if="input.CRMAgentQuickMessageType == 'Mensaje de texto'" style="margin-bottom: 15px;">
            <v-textarea
              ref="CRMAgentQuickTextMessageContent"
              v-model="input.CRMAgentQuickTextMessageContent"
              :append-inner-icon="input.CRMAgentQuickTextMessageContent && /\S/.test(input.CRMAgentQuickTextMessageContent) ? 'mdi-text-box-remove' : 'mdi-text-box'" 
              @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMAgentQuickTextMessageContent'); input.CRMAgentQuickTextMessageContent = null" 
              label="Contenido del mensaje rápido de texto"
              variant="solo-filled"
              density="compact"
              autocomplete="off"
              rows="4"
              max-rows="10"
              auto-grow
              hide-details
            ></v-textarea>
            <p style="font-size: small; color: grey; margin-top: 5px; cursor: default; user-select: none;">El caracter @ se reemplazará por el nombre del cliente</p>
          </div>
          <div v-if="input.CRMAgentQuickMessageType == 'Mensaje multimedia'">
            <v-text-field 
              ref="CRMAgentQuickMediaMessageMediaName"
              v-if="navigation.CRMAgentQuickMessageAction == 'insert'"
              v-model="input.CRMAgentQuickMediaMessageMediaName"
              @click="this.$refs.CRMAgentQuickMediaMessageMediaFile ? this.$refs.CRMAgentQuickMediaMessageMediaFile.click() : null"
              :append-inner-icon="input.CRMAgentQuickMediaMessageMediaName && /\S/.test(input.CRMAgentQuickMediaMessageMediaName) ? 'mdi-image-remove' : 'mdi-image'" 
              @click:append-inner.stop="$generalFunctions.default.blurInput(this, 'CRMAgentQuickMediaMessageMediaName'); input.CRMAgentQuickMediaMessageMediaName = null" 
              label="Contenido multimedia del mensaje rápido"
              variant="solo-filled"
              density="compact"
              autocomplete="off"
              readonly
              hide-details
              style="margin-bottom: 15px;"
            ></v-text-field>
            <input type="file" accept=".jpg,.jpeg,.png,.mp4,.pdf,image/jpeg,image/png,video/mp4,application/pdf" ref="CRMAgentQuickMediaMessageMediaFile" @change="uploadCRMAgentQuickMediaMessageMediaFile" style="display: none;">
            <div v-if="navigation.CRMAgentQuickMessageAction == 'insert' && input.CRMAgentQuickMediaMessageMediaURL && input.CRMAgentQuickMediaMessageMediaExtension" style="display: flex; justify-content: center; align-items: center;">
              <img v-if="input.CRMAgentQuickMediaMessageMediaExtension == 'webp'" :src="input.CRMAgentQuickMediaMessageMediaURL" style="height: 200px; width: auto;">
              <video v-else-if="input.CRMAgentQuickMediaMessageMediaExtension == 'mp4'" :src="input.CRMAgentQuickMediaMessageMediaURL" controls style="height: 200px; width: auto;"></video>
              <iframe v-if="input.CRMAgentQuickMediaMessageMediaExtension == 'pdf'" :src="input.CRMAgentQuickMediaMessageMediaBlob" :title="input.CRMAgentQuickMediaMessageMediaName" draggable="false" style="height: 200px; width: auto;"></iframe>
            </div>
            <v-textarea
              ref="CRMAgentQuickMediaMessageCaption"
              v-if="input.CRMAgentQuickMediaMessageMediaURL && input.CRMAgentQuickMediaMessageMediaExtension"
              v-model="input.CRMAgentQuickMediaMessageCaption"
              :append-inner-icon="input.CRMAgentQuickMediaMessageCaption && /\S/.test(input.CRMAgentQuickMediaMessageCaption) ? 'mdi-text-box-remove' : 'mdi-text-box'" 
              @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMAgentQuickMediaMessageCaption'); input.CRMAgentQuickMediaMessageCaption = null" 
              label="Caption del contenido multimedia del mensaje rápido (opcional)"
              variant="solo-filled"
              density="compact"
              autocomplete="off"
              rows="4"
              max-rows="6"
              auto-grow
              hide-details
              style="margin-top: 15px;"
            ></v-textarea>
          </div>
          <v-tooltip :disabled="validateInputForCRMAgentQuickMessageDialog(false).success || loader.CRMAgentQuickMessageDialogLoader" :text="validateInputForCRMAgentQuickMessageDialog(false).result" location="top"> 
            <template v-slot:activator="{ props }">
              <div v-bind="props">
                <v-btn 
                  @click="validateInputForCRMAgentQuickMessageDialog(true).success ? navigation.CRMAgentQuickMessageAction == 'insert' ? insertCRMAgentQuickMessage() : updateCRMAgentQuickMessage() : null" 
                  :disabled="!validateInputForCRMAgentQuickMessageDialog(false).success || loader.CRMAgentQuickMessageDialogLoader" 
                  :color="navigation.CRMAgentQuickMessageAction == 'insert' ? 'success' : 'warning'" 
                  height="38" 
                  dark 
                  block 
                  class="hoverableText"
                  style="margin-top: 20px;"
                >
                  <h3>{{ navigation.CRMAgentQuickMessageAction == 'insert' ? 'AGREGAR MENSAJE RÁPIDO' : 'ACTUALIZAR MENSAJE RÁPIDO' }}</h3>
                  <v-icon style="margin-left: 10px;" dark right>{{ navigation.CRMAgentQuickMessageAction == 'insert' ? 'mdi-plus-circle' : 'mdi-pencil' }}</v-icon>
                </v-btn>
              </div>
            </template>
            <span style="max-width: 400px; display: block;">{{ validateInputForCRMAgentQuickMessageDialog(false).result }}</span>
          </v-tooltip>
          <v-btn @click="navigation.CRMAgentQuickMessageDialogIsVisible = false" :disabled="loader.CRMAgentQuickMessageDialogLoader" color="error" dark block height="38" class="hoverableText" style="margin-top: 10px;">
            <h3>CANCELAR</h3>
            <v-icon style="margin-left: 10px;" dark right>mdi-close-circle</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>


</template>

<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';

  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: {},
    data: () => ({
      input: 
      {
        CRMAgentQuickMessageSearchQuery: null,
        CRMAgentQuickMessageName: null,
        CRMAgentQuickMessageDescription: null,
        CRMAgentQuickMessageType: null,
        CRMAgentQuickTextMessageContent: null,
        CRMAgentQuickMediaMessageMediaURL: null,
        CRMAgentQuickMediaMessageMediaBlob: null,
        CRMAgentQuickMediaMessageMediaName: null,
        CRMAgentQuickMediaMessageMediaExtension: null,
        CRMAgentQuickMediaMessageCaption: null,
        deleteCRMAgentQuickMessageConfirmation: false
      },
      display: 
      {
        CRMAgentQuickMessagesHeaders:
        [
          {title: 'ID', key: 'CRMAgentQuickMessageID', sortable: false},
          {title: 'NOMBRE', key: 'CRMAgentQuickMessageName', sortable: false},
          {title: 'DESCRIPCIÓN', key: 'CRMAgentQuickMessageDescription', sortable: false},
          {title: 'CONTENIDO', key: 'CRMAgentQuickMessageContent', sortable: false},
          {title: null, key: 'CRMAgentQuickMessageUpdateAction', sortable: false},
          {title: null, key: 'CRMAgentQuickMessageDeleteAction', sortable: false}
        ],
        CRMAgentQuickMessage: []
      },
      navigation: 
      {
        CRMAgentQuickMessageDialogIsVisible: false,
        CRMAgentQuickMessageAction: null,
        CRMAgentQuickMessage: null
      },
      loader: 
      {
        selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponent: false,
        CRMAgentQuickMessageDialogLoader: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        tooltipDisabled: false,
        updateSubscription: null
      },
    }),

    computed: {
      filteredCRMAgentQuickMessage() {
        if (this.input.CRMAgentQuickMessageSearchQuery != null && /\S/.test(this.input.CRMAgentQuickMessageSearchQuery)) {
          return this.display.CRMAgentQuickMessage.filter(CRMAgentQuickMessage => {
            return (
              (CRMAgentQuickMessage.CRMAgentQuickMessageName && CRMAgentQuickMessage.CRMAgentQuickMessageName.toLowerCase().includes(this.input.CRMAgentQuickMessageSearchQuery.toLowerCase())) ||
              (CRMAgentQuickMessage.CRMAgentQuickMessageDescription && CRMAgentQuickMessage.CRMAgentQuickMessageDescription.toLowerCase().includes(this.input.CRMAgentQuickMessageSearchQuery.toLowerCase())) ||
              (CRMAgentQuickMessage.CRMAgentQuickTextMessageContent && CRMAgentQuickMessage.CRMAgentQuickTextMessageContent.toLowerCase().includes(this.input.CRMAgentQuickMessageSearchQuery.toLowerCase())) ||
              (CRMAgentQuickMessage.CRMAgentQuickMediaMessageMediaName && CRMAgentQuickMessage.CRMAgentQuickMediaMessageMediaName.toLowerCase().includes(this.input.CRMAgentQuickMessageSearchQuery.toLowerCase())) ||
              (CRMAgentQuickMessage.CRMAgentQuickMediaMessageCaption && CRMAgentQuickMessage.CRMAgentQuickMediaMessageCaption.toLowerCase().includes(this.input.CRMAgentQuickMessageSearchQuery.toLowerCase()))
            );
          });
        }
        return this.display.CRMAgentQuickMessage;
      }
    },

    methods: {
      async selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponent() {
        this.loader.selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponent = true;
        const selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponentRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          }
        };
        const selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponentResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/CRMAgentQuickMessage/functions/selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponent', selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponentRequestQuery);
        if (selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponentResult.success){
          this.display.CRMAgentQuickMessage = selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponentResult.result;
          this.display.CRMAgentQuickMessage.forEach(async CRMAgentQuickMessage => {
            if (CRMAgentQuickMessage.CRMAgentQuickMediaMessageMediaExtension == 'pdf') CRMAgentQuickMessage.CRMAgentQuickMediaMessageMediaBlob = URL.createObjectURL((await (await fetch(CRMAgentQuickMessage.CRMAgentQuickMediaMessageMediaURL)).blob()));
          });
          this.loader.selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponent = false;
          if (this.display.CRMAgentQuickMessage.length == 0) this.$root.notificationDialog.showSystemNotificationDialog('selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponent_info', 'info', 'No se ha encontrado ningún mensaje rápido para este agente', null, true);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponent_error', 'error', 'Ha ocurrido un error inesperado al consultar los mensajes rápidos del agente, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        } 
      },

      async insertCRMAgentQuickMessage(){
        this.loader.CRMAgentQuickMessageDialogLoader = true;
        const insertCRMAgentQuickMessageRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMAgentQuickMessageName': this.input.CRMAgentQuickMessageName,
          'CRMAgentQuickMessageDescription': this.input.CRMAgentQuickMessageDescription,
          'CRMAgentQuickTextMessageContent': this.input.CRMAgentQuickTextMessageContent ? this.input.CRMAgentQuickTextMessageContent.trim() : null,
          'CRMAgentQuickMediaMessageMediaURL': this.input.CRMAgentQuickMediaMessageMediaURL,
          'CRMAgentQuickMediaMessageMediaName': this.input.CRMAgentQuickMediaMessageMediaName,
          'CRMAgentQuickMediaMessageMediaExtension': this.input.CRMAgentQuickMediaMessageMediaExtension,
          'CRMAgentQuickMediaMessageCaption': this.input.CRMAgentQuickMediaMessageCaption ? this.input.CRMAgentQuickMediaMessageCaption.trim() : null
        };
        const insertCRMAgentQuickMessageResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/CRMAgentQuickMessage/functions/insertCRMAgentQuickMessage', insertCRMAgentQuickMessageRequestQuery);
        if (insertCRMAgentQuickMessageResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('insertCRMAgentQuickMessage_success', 'success', `El mensaje rápido ${this.input.CRMAgentQuickMessageName} ha sido agregado`, null, true);
          this.display.CRMAgentQuickMessage = [...this.display.CRMAgentQuickMessage, insertCRMAgentQuickMessageResult.result];
          this.display.CRMAgentQuickMessage.sort((CRMAgentQuickMessageA, CRMAgentQuickMessageB) => CRMAgentQuickMessageB.CRMAgentQuickMessageID - CRMAgentQuickMessageA.CRMAgentQuickMessageID);
          this.navigation.CRMAgentQuickMessageDialogIsVisible = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('insertCRMAgentQuickMessage_error', 'error', `Ha ocurrido un error inesperado al agregar el mensaje rápido ${this.input.CRMAgentQuickMessageName}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.loader.CRMAgentQuickMessageDialogLoader = false;
      },

      async updateCRMAgentQuickMessage(){
        this.loader.CRMAgentQuickMessageDialogLoader = true;
        const updateCRMAgentQuickMessageRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMAgentQuickMessageID': this.navigation.CRMAgentQuickMessage.CRMAgentQuickMessageID,
          'CRMAgentQuickMessageName': this.input.CRMAgentQuickMessageName,
          'CRMAgentQuickMessageDescription': this.input.CRMAgentQuickMessageDescription,
          'CRMAgentQuickTextMessageContent': this.input.CRMAgentQuickTextMessageContent ? this.input.CRMAgentQuickTextMessageContent.trim() : null,
          'CRMAgentQuickMediaMessageCaption': this.input.CRMAgentQuickMediaMessageCaption ? this.input.CRMAgentQuickMediaMessageCaption.trim() : null
        };
        const updateCRMAgentQuickMessageResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/CRMAgentQuickMessage/functions/updateCRMAgentQuickMessage', updateCRMAgentQuickMessageRequestQuery);
        if (updateCRMAgentQuickMessageResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentQuickMessage_success', 'success', `El mensaje rápido ${this.input.CRMAgentQuickMessageName} ha sido actualizado`, null, true);
          const updatedCRMAgentQuickMessage = this.display.CRMAgentQuickMessage.find(CRMAgentQuickMessage => CRMAgentQuickMessage.CRMAgentQuickMessageID == this.navigation.CRMAgentQuickMessage.CRMAgentQuickMessageID);
          if (updatedCRMAgentQuickMessage){
            updatedCRMAgentQuickMessage.CRMAgentQuickMessageName = this.input.CRMAgentQuickMessageName;
            updatedCRMAgentQuickMessage.CRMAgentQuickMessageDescription = this.input.CRMAgentQuickMessageDescription;
            updatedCRMAgentQuickMessage.CRMAgentQuickTextMessageContent = this.input.CRMAgentQuickTextMessageContent ? this.input.CRMAgentQuickTextMessageContent.trim() : null;
            updatedCRMAgentQuickMessage.CRMAgentQuickMediaMessageCaption = this.input.CRMAgentQuickMediaMessageCaption;
          }
          this.navigation.CRMAgentQuickMessageDialogIsVisible = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentQuickMessage_error', 'error', `Ha ocurrido un error inesperado al actualizar el mensaje rápido ${this.input.CRMAgentQuickMessageName}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.loader.CRMAgentQuickMessageDialogLoader = false;
      },

      async deleteCRMAgentQuickMessage(){
        this.loader.CRMAgentQuickMessageDialogLoader = true;
        const deleteCRMAgentQuickMessageRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMAgentQuickMessageID': this.navigation.CRMAgentQuickMessage.CRMAgentQuickMessageID,
          'CRMAgentQuickMessageIndex': this.navigation.CRMAgentQuickMessage.CRMAgentQuickMessageIndex
        };
        const deleteCRMAgentQuickMessageResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/CRMAgentQuickMessage/functions/deleteCRMAgentQuickMessage', deleteCRMAgentQuickMessageRequestQuery);
        if (deleteCRMAgentQuickMessageResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMAgentQuickMessage_success', 'success', `El mensaje rápido ${this.input.CRMAgentQuickMessageName} ha sido eliminado`, null, true);
          this.display.CRMAgentQuickMessage = this.display.CRMAgentQuickMessage.filter(CRMAgentQuickMessage => CRMAgentQuickMessage.CRMAgentQuickMessageID != this.navigation.CRMAgentQuickMessage.CRMAgentQuickMessageID);
          this.navigation.CRMAgentQuickMessageDialogIsVisible = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMAgentQuickMessage_error', 'error', `Ha ocurrido un error inesperado al eliminar el mensaje rápido ${this.input.CRMAgentQuickMessageName}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.loader.CRMAgentQuickMessageDialogLoader = false;
      },

      validateInputForCRMAgentQuickMessageDialog(showSystemNotificationDialog){
        if (this.input.CRMAgentQuickMessageName == null || !/\S/.test(this.input.CRMAgentQuickMessageName)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMAgentQuickMessageDialog_missingName', 'info', 'El nombre del mensaje rápido es obligatorio', null, true);
          return {success: false, result: 'El nombre del mensaje rápido es obligatorio'};
        } else if (this.input.CRMAgentQuickMessageName.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMAgentQuickMessageDialog_nameTooLong', 'info', 'El nombre del mensaje rápido no puede tener exceder los 100 caracteres', null, true);
          return {success: false, result: 'El nombre del mensaje rápido no puede tener exceder los 100 caracteres'};
        } else if (this.input.CRMAgentQuickMessageDescription != null && this.input.CRMAgentQuickMessageDescription.length > 65355){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMAgentQuickMessageDialog_descriptionTooLong', 'info', 'La descripción del mensaje rápido no puede tener exceder los 65355 caracteres', null, true);
          return {success: false, result: 'La descripción del mensaje rápido no puede tener exceder los 65355 caracteres'};
        } else if (this.input.CRMAgentQuickMessageType == null){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMAgentQuickMessageDialog_missingType', 'info', 'El tipo de mensaje rápido es obligatorio', null, true);
          return {success: false, result: 'El tipo de mensaje rápido es obligatorio'};
        }
        if (this.input.CRMAgentQuickMessageType == 'Mensaje de texto'){
          if (this.input.CRMAgentQuickTextMessageContent == null || !/\S/.test(this.input.CRMAgentQuickTextMessageContent)){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMAgentQuickMessageDialog_missingTextMessageContent', 'info', 'El contenido del mensaje rápido de texto es obligatorio', null, true);
            return {success: false, result: 'El contenido del mensaje rápido de texto es obligatorio'};
          } else if (this.input.CRMAgentQuickTextMessageContent.length > 65535){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMAgentQuickMessageDialog_textMessageContentTooLong', 'info', 'El contenido del mensaje rápido de texto no puede tener exceder los 65535 caracteres', null, true);
            return {success: false, result: 'El contenido del mensaje rápido de texto no puede tener exceder los 65535 caracteres'};
          }
        } else if (this.input.CRMAgentQuickMessageType == 'Mensaje multimedia'){
          if (this.input.CRMAgentQuickMediaMessageMediaURL == null || this.input.CRMAgentQuickMediaMessageMediaExtension == null){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMAgentQuickMessageDialog_missingMediaMessageMedia', 'info', 'El contenido multimedia del mensaje rápido es obligatorio', null, true);
            return {success: false, result: 'El contenido multimedia del mensaje rápido es obligatorio'};
          } else if (this.input.CRMAgentQuickMediaMessageCaption != null && this.input.CRMAgentQuickMediaMessageCaption.length > 65355){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMAgentQuickMessageDialog_captionTooLong', 'info', 'El caption del contenido multimedia del mensaje rápido no puede tener exceder los 65355 caracteres', null, true);
            return {success: false, result: 'El caption del contenido multimedia del mensaje rápido no puede tener exceder los 65355 caracteres'};
          }
        }
        return {success: true, result: null};
      },


      async uploadCRMAgentQuickMediaMessageMediaFile(uploadCRMAgentQuickMediaMessageMediaFileEvent) {
        const CRMWhatsappMediaMessageMediaFile = uploadCRMAgentQuickMediaMessageMediaFileEvent.target.files[0];
        if (!CRMWhatsappMediaMessageMediaFile) return;
        if (CRMWhatsappMediaMessageMediaFile.size > 10485760) {
          this.$root.notificationDialog.showSystemNotificationDialog('uploadCRMAgentQuickMediaMessageMediaFile_error', 'error', 'El archivo del mensaje no puede pesar más de 10MB, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          uploadCRMAgentQuickMediaMessageMediaFileEvent.target.value = '';
          return;
        }
        const CRMWhatsappMediaMessageMediaName = CRMWhatsappMediaMessageMediaFile.name;
        const CRMWhatsappMediaMessageFileReader = new FileReader();
        CRMWhatsappMediaMessageFileReader.onload = async () => {
          let CRMWhatsappMediaMessageMediaExtension = CRMWhatsappMediaMessageMediaFile.type.split('/')[0];
          if (['image', 'video', 'application'].includes(CRMWhatsappMediaMessageMediaExtension)) {
            CRMWhatsappMediaMessageMediaExtension = {'image': 'webp', 'video': 'mp4', 'application': 'pdf'}[CRMWhatsappMediaMessageMediaExtension];
            this.input.CRMAgentQuickMediaMessageMediaURL = CRMWhatsappMediaMessageFileReader.result;
            this.input.CRMAgentQuickMediaMessageMediaBlob = CRMWhatsappMediaMessageMediaExtension == 'pdf' ? URL.createObjectURL((await (await fetch(this.input.CRMAgentQuickMediaMessageMediaURL)).blob())) : null;
            this.input.CRMAgentQuickMediaMessageMediaName = CRMWhatsappMediaMessageMediaName ? CRMWhatsappMediaMessageMediaName : (`${Math.random().toString(36).substring(2, 15)}.${CRMWhatsappMediaMessageMediaExtension}`);
            this.input.CRMAgentQuickMediaMessageMediaExtension = CRMWhatsappMediaMessageMediaExtension;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('uploadCRMAgentQuickMediaMessageMediaFile_error', 'error', 'El sistema solo permite el envío de archivos de tipo imagen, video o PDF, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
        };
        CRMWhatsappMediaMessageFileReader.onerror = () => {
          this.$root.notificationDialog.showSystemNotificationDialog('uploadCRMAgentQuickMediaMessageMediaFile_error', 'error', 'Ha ocurrido un error inesperado al cargar el archivo del mensaje, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        };
        CRMWhatsappMediaMessageFileReader.readAsDataURL(CRMWhatsappMediaMessageMediaFile);
      },


      openCRMAgentQuickMessageDialog(CRMAgentQuickMessageAction, CRMAgentQuickMessage) {
        this.input.CRMAgentQuickMessageName = CRMAgentQuickMessage ? CRMAgentQuickMessage.CRMAgentQuickMessageName : null;
        this.input.CRMAgentQuickMessageDescription = CRMAgentQuickMessage ? CRMAgentQuickMessage.CRMAgentQuickMessageDescription : null;
        this.input.CRMAgentQuickMessageType = CRMAgentQuickMessage ? (CRMAgentQuickMessage.CRMAgentQuickTextMessageContent ? 'Mensaje de texto' : 'Mensaje multimedia') : null;
        this.input.CRMAgentQuickTextMessageContent = CRMAgentQuickMessage ? CRMAgentQuickMessage.CRMAgentQuickTextMessageContent : null;
        this.input.CRMAgentQuickMediaMessageMediaURL = CRMAgentQuickMessage ? CRMAgentQuickMessage.CRMAgentQuickMediaMessageMediaURL : null;
        this.input.CRMAgentQuickMediaMessageMediaBlob = null;
        this.input.CRMAgentQuickMediaMessageMediaName = CRMAgentQuickMessage ? CRMAgentQuickMessage.CRMAgentQuickMediaMessageMediaName : null;
        this.input.CRMAgentQuickMediaMessageMediaExtension = CRMAgentQuickMessage ? CRMAgentQuickMessage.CRMAgentQuickMediaMessageMediaExtension : null;
        this.input.CRMAgentQuickMediaMessageCaption = CRMAgentQuickMessage ? CRMAgentQuickMessage.CRMAgentQuickMediaMessageCaption : null;
        this.input.deleteCRMAgentQuickMessageConfirmation = false;
        this.loader.CRMAgentQuickMessageDialogLoader = false;
        this.navigation.CRMAgentQuickMessageAction = CRMAgentQuickMessageAction;
        this.navigation.CRMAgentQuickMessage = CRMAgentQuickMessage;
        this.navigation.CRMAgentQuickMessageDialogIsVisible = true;
        this.$generalFunctions.default.focusInput(this, 'CRMAgentQuickMessageName');
      },

      async getSystemInformation() {
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

    },

    async mounted() {
      await this.getSystemInformation();
      await this.selectCRMAgentQuickMessageFromCRMAgentQuickMessagesComponent();
    }
  }
</script>
